import { z } from 'zod';
import { meta } from '../meta';

export const FormFieldTypeSchema = z.enum(['input', 'textarea', 'select', 'radio', 'checkbox', 'phone']);
export type FormFieldType = z.infer<typeof FormFieldTypeSchema>;

/** 单个表单字段定义。编辑器 formFields setter 与服务端存储都用它。 */
export const FormFieldSchema = z.object({
  id: z.string().min(1),
  type: FormFieldTypeSchema,
  label: z.string().default(''),
  placeholder: z.string().default(''),
  required: z.boolean().default(false),
  /** select / radio / checkbox 的选项 */
  options: z.array(z.string()).default([]),
});
export type FormField = z.infer<typeof FormFieldSchema>;

export const FormPropsSchema = z.object({
  fields: z.array(FormFieldSchema).default([
    { id: 'name', type: 'input', label: '姓名', placeholder: '请输入姓名', required: true, options: [] },
    { id: 'phone', type: 'phone', label: '手机号', placeholder: '请输入手机号', required: true, options: [] },
  ]).meta(meta({ label: '字段', setter: 'formFields' })),
  submitText: z.string().default('提交').meta(meta({ label: '按钮文字', setter: 'input', group: '提交' })),
  submitColor: z.string().default('#1677ff').meta(meta({ label: '按钮颜色', setter: 'color', group: '提交' })),
  successText: z.string().default('提交成功').meta(meta({ label: '成功提示', setter: 'input', group: '提交' })),
});

export type FormProps = z.infer<typeof FormPropsSchema>;
